// French date and time formats shared by the screens of the platform.

const relative = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' });
const UNITS = [
  ['year', 31536000],
  ['month', 2592000],
  ['week', 604800],
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60],
];

const toDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

// "il y a 3 heures", "hier"
export const timeAgo = (value) => {
  const date = toDate(value);
  if (!date) return '';
  const seconds = (date.getTime() - Date.now()) / 1000;
  const unit = UNITS.find(([, size]) => Math.abs(seconds) >= size);
  return unit ? relative.format(Math.round(seconds / unit[1]), unit[0]) : 'à l’instant';
};

// "12 mars 2026"
export const formatDate = (value) => {
  const date = toDate(value);
  return date ? date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
};

// "12 mars 2026 à 14:05"
export const formatDateTime = (value) => {
  const date = toDate(value);
  return date
    ? `${formatDate(date)} à ${date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
    : '';
};

// "Lundi 28 septembre"
export const todayLabel = () => {
  const text = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  return text.charAt(0).toUpperCase() + text.slice(1);
};

// Whole years since a birth date.
export const yearsSince = (value) => {
  const birth = toDate(value);
  if (!birth) return null;
  const today = new Date();
  let years = today.getFullYear() - birth.getFullYear();
  const beforeBirthday =
    today.getMonth() < birth.getMonth() || (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate());
  if (beforeBirthday) years -= 1;
  return years >= 0 && years < 130 ? years : null;
};

// Date inputs expect "YYYY-MM-DD".
export const toInputDate = (value) => {
  if (!value) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = toDate(value);
  return date ? date.toISOString().slice(0, 10) : '';
};
